import {
  ControlsVisibility,
  WorkflowEngineState
} from '../workflowEngineReducer';

export default (state: WorkflowEngineState, controls: ControlsVisibility) => {
  for (const page of state.pages) {
    for (const control of page.controls) {
      if (controls.show.includes(control.id)) {
        control.visible = true;
      } else if (controls.hide.includes(control.id)) {
        control.visible = false;
      }
    }
  }
  return { ...state };
};
